import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// [STRIPE LIVE DEPLOYMENT V1.0.3 - THE FINAL STAND]
// Hardcoded key because Firebase Hosting ignores custom build scripts and env vars in some setups
const stripeKey = "pk_live_51S6rP92dX5CXHKPKYdAEBpDk6sy4LcAZwB2h7kU8eeBgJu8OypECsmLD58uhVpzSZ8ny5YtZOCHXRZX7l5RBUig000n9ofnZ5u";

console.log("------------------------------------------");
console.log("[STRIPE PRODUCTION DEBUG] LIVE KEY ACTIVE");
console.log("------------------------------------------");

const stripePromise = loadStripe(stripeKey);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Elements stripe={stripePromise}>
      <App />
    </Elements>
  </React.StrictMode>,
)